<div
    id="root"
    [class.has-notification-bar]="hasNotificationBar"
    [class.has-primary-nav]="hasPrimaryNav"
    [appshell-deactivate-area]="[AppShellAreaType.SidebarLocalLeft]"
    [priva-toggle-class]="{ contentActions: 'has-content-overlay' }"
    [priva-toggle-deactivate]="['contentActions', 'showPrimaryNavItems']"
>
    <!-- AREA | COMPONENT: Notification messages -->
    <priva-notifications />

    @if (authStore.hasReadAccess() === false && authStore.hasWriteAccess() === false) {
        <priva-status-global
            [title]="'APP.AUTHORIZATION.NO_READ_ACCESS' | translate"
            status="danger"
            [hasImage]="true"
        >
            <priva-illustration data-image illustrationName="service-access-denied" />
            <ng-container>
                <p translate="APP.AUTHORIZATION.NO_READ_ACCESS_HELP"></p>
            </ng-container>
        </priva-status-global>
    } @else {
        <!-- App Shell main component -->
        <router-outlet />
    }
</div>
